import { Link } from "react-router-dom";
import "./Auth.css";

interface AuthShellProps {
    children: React.ReactNode;
    eyebrow: string;
    title: string;
    description: React.ReactNode;
}

export default function AuthShell({ children, eyebrow, title, description }: AuthShellProps) {
    return (
        <main className="auth-page">
            <header className="auth-page__masthead">
                <Link to="/" className="auth-page__brand" aria-label="Lrner home">
                    LRNER
                </Link>
                <span>one account, all of lrner</span>
            </header>

            <section className="auth-card" aria-labelledby="auth-title">
                <div className="auth-card__heading">
                    <p>{eyebrow}</p>
                    <h1 id="auth-title">{title}</h1>
                    <div className="auth-card__description">{description}</div>
                </div>
                {children}
            </section>
        </main>
    );
}
